import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useTransportListModel} from "@/stores/models/transport-list-model";

export const useTransportListStore  = defineStore(
    'transportListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceTransportList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useTransportListModel().transportListCustomStore,
                filter: null
            })
        );
    // const dataSourceTransportList = (additionalParams = null) => {
    //         return new DataSource({
    //           requireTotalCount: true,
    //           load: (loadOptions) => {
    //             // Handle load options and additionalParams separately
    //             return useTransportListModel().transportListCustomStore.load([loadOptions, additionalParams]);
    //           }
    //         });
    //     };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceTransportList.value.reload();
        };

        const initialized = ()=>{     
            //  useTransportListModel().setFilter(null);    
            dataSourceTransportList.value.reload();
        };

        return {
            dataSourceTransportList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);